import React from "react";
import Header4 from "./../Common/Header4";
import Footer2 from "./../Common/Footer2";
import Banner from "./../Elements/Banner";
import About3 from "./../Elements/About3";
import Statistics1 from "./../Elements/Statistics1";
import Team1 from "./../Elements/Team1";
import ContactUs1 from "./../Elements/ContactUs1";

var bnrimg = require("./../../images/page_banners/Banner1.JPEG");

class Home4 extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/custom.js");
  }
  render() {
    return (
      <>
        <Header4 />
        <div className="page-content">
          <Banner title="Our Company" pagename="Our Company" bgimage={bnrimg} />
          <About3 />
          <Statistics1 />
          <Team1 />
          <ContactUs1 />
        </div>

        <Footer2 />
      </>
    );
  }
}

export default Home4;
